import type { ProductCategoryType, ProductIndustryCategory } from "../../types";

export type ProductPreviewData = {
  productName: string;
  productDescription: string;
  productCategory: ProductCategoryType;
  pictures: Array<{
    mediaPath: string;
    type: string;
  }>;
  packages: Array<{
    packageId?: number;
    name: string;
    isFreeTrial?: boolean;
    specifications: string[];
    variants: Array<{
      variantId?: number;
      quantity: number;
      unit: string;
      price: number;
      provisioningId?: string;
    }>;
  }>;
  provideTrial: boolean;
  industryCategory: ProductIndustryCategory[];
  companyBrandName: string;
  apiPackage?: {
    host?: string;
    header?: string;
    key?: string;
    apis?: Array<{
      name?: string;
      endpoint?: string;
      method?: string;
      body?: Array<{ key?: string; type?: string }>;
      response?: string;
    }>;
  };
};

export const PREVIEW_STORAGE_KEY = "product_preview_data";
